const STEPS = [
  { n: 1, label: "Discovery call within 48 hours" },
  { n: 2, label: "1:1 with the founder" },
  { n: 3, label: "Licensing & onboarding (if not licensed)" },
  { n: 4, label: "Academy week" },
  { n: 5, label: "Launch with a mentor" },
];

export function ApplyTimeline() {
  return (
    <aside className="lg:sticky lg:top-24 space-y-8">
      <div>
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-bronze-600">
          What happens after you apply
        </p>
        <ol className="mt-6 space-y-5">
          {STEPS.map((s) => (
            <li key={s.n} className="flex items-start gap-4">
              <span
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-bronze-600 bg-cream-50 font-serif text-[16px] text-bronze-600"
                aria-hidden
              >
                {s.n}
              </span>
              <span className="font-sans text-[13px] leading-[1.6] text-charcoal-900 pt-1.5">
                {s.label}
              </span>
            </li>
          ))}
        </ol>
      </div>
      <div
        className="border-t pt-6 space-y-2"
        style={{ borderColor: "rgba(168,139,92,0.4)" }}
      >
        {[
          "We respond personally",
          "No mass-recruiting funnel",
          "If you're not a fit, we'll say so",
        ].map((t) => (
          <p
            key={t}
            className="font-sans text-[12px] text-charcoal-500 flex items-center gap-2"
          >
            <span className="h-1 w-1 rounded-full bg-bronze-600" aria-hidden />
            {t}
          </p>
        ))}
      </div>
    </aside>
  );
}